var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoletosIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 38,
    viewBox: "0 0 34 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 34.6C33 35.2365 32.7407 35.847 32.279 36.2971C31.8174 36.7471 31.1913 37 30.5385 37H3.46154C2.8087 37 2.1826 36.7471 1.72097 36.2971C1.25934 35.847 1 35.2365 1 34.6V3.4C1 2.76348 1.25934 2.15303 1.72097 1.70294C2.1826 1.25286 2.8087 1 3.46154 1H20.904C21.5564 1.00014 22.182 1.25277 22.6435 1.7024L32.2796 11.0976C32.7407 11.5475 32.9999 12.1575 33 12.7936V34.6Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.667 12.5714H22.067C21.4305 12.5714 20.82 12.3276 20.3699 11.8936C19.9198 11.4596 19.667 10.8709 19.667 10.2571V1",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65655 17.7258C7.0069 18.1392 7.46302 18.4707 7.98625 18.6921C8.50948 18.9135 9.0844 19.0183 9.6623 18.9977C11.5049 18.9977 12.9997 17.9903 12.9997 16.749C12.9997 15.5076 11.5097 14.5017 9.66877 14.5017C7.82779 14.5017 6.33301 13.4944 6.33301 12.2516C6.33301 11.0087 7.82779 10.0029 9.66877 10.0029C10.2467 9.98181 10.8218 10.0865 11.3451 10.3079C11.8684 10.5293 12.3244 10.861 12.6745 11.2748",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.667 22.857H26.3337",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66699 30.571H26.3337",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoletosIcon);
export default __webpack_public_path__ + "static/media/boletos-icon.05c45daac3860e7381f4eb66cd459f50.svg";
export { ForwardRef as ReactComponent };